export const reservationDrawer = {
  title: "Szczegóły rezerwacji",
  openFullPage: "Otwórz na pełnej stronie",
  close: "Zamknij",
};
